import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDisplayName(value?: string | null) {
  if (!value) return "";
  return value.replace(/\b([a-z])/g, (match) => match.toUpperCase());
}

 
